export const tokens = {
    zindex: {
        base: 1,
        input: 2,
        label: 3,
        prefix: 4,
        suffix: 5,
    },
    gap: {
        tiny: 4,
        small: 6,
        medium: 8,
        large: 12,
        huge: 16,
    },
    padding: {
        tiny: 10,
        small: 12,
        medium: 16,
        large: 20,
        huge: 24,
    },
    height: {
        tiny: 32,
        small: 40,
        medium: 60,
        large: 80,
        huge: 100,
    },
    fontSize: {
        tiny: 13,
        small: 14,
        medium: 16,
        large: 18,
        huge: 22,
    },
};
